module.exports = __webpack_public_path__ + "img/contaSiphons.b4e991e1.jpg";